export const getSearchData = (state) =>
  state.search.results.find((i) => i.title === 'spaces').data || [];

export default {};
